export default {
  empty: 'Keine Teilinstanzen gefunden.',
  addPart: 'Teil hinzufügen',
  editPart: 'Teil bearbeiten',
  createOrder: 'Auftrag erstellen',
  selectOrder: 'Auftrag auswählen (optional)',
  selectRevision: 'Teilrevision auswählen',
  confirmDelete: 'Teil "{part}" aus dieser Charge löschen?',
};
